import React from 'react'
import { Container, Typography, Button, Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'
import useStyles from './styles'
import CardItem from './CartItem/CartItem'

const Cart = ({ cart,  handleUpdateCartQty, handleRemoveFromCart, handleEmptyCart }) => {

  const isEmpty = !cart?.line_items?.length;
  const classes = useStyles();

  const EmptyCart = () => (
    <Typography variant="subtitle1">
      You have no items in your shopping cart, <Link to="/" className={classes.link}>start adding some!</Link>
    </Typography>
  );

  const FilledCart = () => (
    <React.Fragment>
      <Grid container spacing={3}>
        {cart?.line_items.map((item) => (
          <Grid item xs={12} sm={4} key={item.id}>
            <CardItem item={item} onUpdateCartQty={handleUpdateCartQty} onRemoveFromCart={handleRemoveFromCart}/> 
          </Grid>
        ))}
      </Grid>
      <div className={classes.cardDetails}>
          <Typography variant="h4">Subtotal: { cart.subtotal.formatted_with_symbol}</Typography>
          <div>
            <Button 
              className={classes.emptyButton} 
              size="large" 
              type="button" 
              variant="contained" 
              color="secondary"
              onClick={handleEmptyCart}>
                Empty card
            </Button>
            <Button 
              component={Link}
              to="/checkout"
              className={classes.checkOut} 
              size="large"
              type="button" 
              variant="contained" 
              color="primary">
                Checkout
            </Button>
          </div>
      </div>
    </React.Fragment>
  )

  if(!cart.line_items) return 'Loading...';

  return (
    <Container>
      <div className={classes.toolbar}/>
      <Typography className={classes.title} variant="h3" gutterBottom>Your Shopping Cart</Typography>
      { isEmpty ? <EmptyCart /> : <FilledCart />}
    </Container>
  )
}

export default Cart